import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AdCardListItem from '../../../../../../../features/components/AdCardListItem'
import AdCardMetric from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'
import FacebookSocialPostPreview from '../../../../../../../features/components/FacebookPreviews/FacebookSocialPostPreview'

import { renderMetricValue } from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'
import { getFormattedFacebookSocialPostData } from './helpers'

import useAdCardMetricsClasses from '../../../../../../CampaignsSummary/AdsList/FacebookAdsPreviewList/FacebookAdCardListItem/AdCardMetrics/styles'
import useAdPreviewStyles from '../../../../../../CampaignsSummary/AdsList/FacebookAdsPreviewList/FacebookAdCardListItem/AdCardPreview/styles'
import useStyles from '../../styles'

const FacebookSocialPostCard = ({ post, facebookPageData }) => {
  const adCardMetricsClasses = useAdCardMetricsClasses()
  const adPreviewClasses = useAdPreviewStyles({})
  const classes = useStyles()

  const formattedPost = useMemo(
    () => getFormattedFacebookSocialPostData(post, facebookPageData),
    [facebookPageData, post]
  )

  const { impressions, reach, frequency, clicks, ctr, reactions, videoViews } = formattedPost

  return (
    <AdCardListItem>
      <div
        className={classnames(
          adPreviewClasses.adPreviewWrapper,
          classes.adPreviewWrapper,
          classes.facebookAdPreviewWrapper
        )}
      >
        <FacebookSocialPostPreview formattedPost={formattedPost} />
      </div>
      <AdCardMetric>
        <div>Total Impressions</div>
        <div>{renderMetricValue(impressions)}</div>
      </AdCardMetric>
      <AdCardMetric>
        <div>
          Reach <span className={adCardMetricsClasses.metricAdditional}>(Frequency)</span>
        </div>
        <div>
          {renderMetricValue(reach)}{' '}
          <span className={adCardMetricsClasses.metricAdditional}>({renderMetricValue(frequency)})</span>
        </div>
      </AdCardMetric>
      <AdCardMetric>
        <div>
          Clicks <span className={adCardMetricsClasses.metricAdditional}>(CTR)</span>
        </div>
        <div>
          {renderMetricValue(clicks)}{' '}
          <span className={adCardMetricsClasses.metricAdditional}>({renderMetricValue(ctr)})</span>
        </div>
      </AdCardMetric>
      <AdCardMetric>
        <div>Reactions</div>
        <div>{renderMetricValue(reactions)}</div>
      </AdCardMetric>
      {!!videoViews && (
        <AdCardMetric>
          <div>Video Views</div>
          <div>{renderMetricValue(videoViews)}</div>
        </AdCardMetric>
      )}
    </AdCardListItem>
  )
}

FacebookSocialPostCard.propTypes = {
  post: PropTypes.object,
  facebookPageData: PropTypes.object
}

export default FacebookSocialPostCard
